import { canViewOwnPreference } from "@/permissions/preferences";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { usePhysicianTemplate } from "./usePhysicianTemplate";

/**
 * Returns a handler that uses SWR-cached template_id and navigates to customize report,
 * or shows an error toast. Data may prefetch while the user is signed in.
 */
export function useNavigateToCustomizeReport() {
  const navigate = useNavigate();
  const { user, firmContext } = useAuth();
  const physicianId = canViewOwnPreference(firmContext) ? user?.id : null;

  const { data, errorMessage } = usePhysicianTemplate(physicianId);

  return useCallback(() => {
    if (!user?.id) {
      toast.error("You must be signed in.");
      return;
    }

    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }

    const template_id = data?.template_id;
    if (!template_id) {
      toast.error("No active template found for your profile.");
      return;
    }

    navigate(`/templates/${template_id}`);
  }, [navigate, user?.id, firmContext, data, errorMessage]);
}
